import {formatAsMap} from '@buildium/angularjs-core/dist/constants';
import { find } from 'lodash';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const ROLE_NAME_MAX_LENGTH = 100;

const actions = {
    getUserRoles: {
        method: 'GET',
        url: `${BASE_PATH_API}/userRoles`,
        params: {
            '$count': true
        }
    },
    getUserRole: {
        method: 'GET',
        url: `${BASE_PATH_API}/userRoles/new`,
        params: {
            '$count': true
        }
    },
    getUserRoleByRoleId: {
        method: 'GET',
        url: `${BASE_PATH_API}/userRoles/:roleId`,
        params: {
            '$count': true
        }
    },
    deleteUserRole: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/userRoles/:roleId`
    },
    revertUserRole: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/userRoles/:roleId/revert`
    },
    addUserRole: {
        method: 'POST',
        url: `${BASE_PATH_API}/userRoles`
    },
    updateUserRole: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userRoles/:roleId`
    },
    updateUserRolePermissions: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userRoles/:roleId/menu`
    },
    updateUserRoleReportPermissions: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userRoles/:roleId/report`
    },
    updateUserControlPermissions: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userRoles/:roleId/userControl`
    },
    updatePartnerPortalPermissions: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userRoles/:roleId/partnerPortal`
    },
    duplicateUserRoleAndGetNew: {
        method: 'POST',
        url: `${BASE_PATH_API}/userRoles/copy/:roleId`
    }
};
export function UserRolesApi(PERMISSION_GROUP_ENUM, PERMISSION, ACCESS_LEVEL) {
    const service = createActions(actions);

    service.getUserRolePermission = function getUserRoleName(userRole) {
        const permissionGroups = formatAsMap(PERMISSION_GROUP_ENUM);
        const userRoleSetting = find(userRole.MenuPermissions, menu => menu.Id === permissionGroups.Settings);
        let userRoleAccessLevel = 0;
        const userRoleSettingPermission = find(userRoleSetting.Permissions,  permission => permission.FunctionId === PERMISSION.UserRoles);
        if (userRoleSetting && userRoleSetting.Permissions && userRoleSettingPermission) {
            userRoleAccessLevel = userRoleSettingPermission.AccessLevel;
        }

        return {
            hasDeleteAccess: userRoleAccessLevel >= ACCESS_LEVEL.AddEditDelete,
            hasEditAccess: userRoleAccessLevel >= ACCESS_LEVEL.AddEdit
        };
    };

    service.getUserRoleName = function getUserRoleName(roleName) {
        if (roleName.length > ROLE_NAME_MAX_LENGTH) {
            let tempRoleName = roleName;
            tempRoleName = tempRoleName.substr(0, ROLE_NAME_MAX_LENGTH - 1);
            let position = tempRoleName.lastIndexOf(' ');
            if (position > ROLE_NAME_MAX_LENGTH - 4) {
                position = roleName.substr(0, position).lastIndexOf(' ');
            }

            if (position <= 0) position = ROLE_NAME_MAX_LENGTH - 4;
            tempRoleName = `${roleName.substr(0, position)}...`;
            return tempRoleName;
        }
        return  roleName;
    };
    return service;
}
UserRolesApi.$inject = ['PERMISSION_GROUP_ENUM', 'PERMISSION', 'ACCESS_LEVEL'];
